import HttpClienteToken from '../../services/HttpClientToken';

import { TipoDomicilioProps } from '../../interfaces/catalogos/TipoDomicilioInterface';

export const TipoDomicilio = () => {

    return new Promise<TipoDomicilioProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoDomicilio/', token)
            .then( ({ data } : { data : TipoDomicilioProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerTipoDomicilio = () => {

    return new Promise<TipoDomicilioProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoDomicilio/ObtenerTipoDomicilio', token)
            .then( ({ data } : { data : TipoDomicilioProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarTipoDomicilio = ( params: TipoDomicilioProps ) => {

    return new Promise<TipoDomicilioProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoDomicilio/Actualizar', params, token)
            .then( ({ data } : { data : TipoDomicilioProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoDomicilio: 0,                 
                    descripcion: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarTipoDomicilio = ( params: TipoDomicilioProps ) => {

    return new Promise<TipoDomicilioProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoDomicilio/Agregar', params, token)
            .then( ({ data } : { data : TipoDomicilioProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoDomicilio: 0,                   
                    descripcion: '',
                    activo: false,    
                });
            });
        }

    });

}